// extracted by mini-css-extract-plugin
export default {"Wrapper":"LogoWrapper_Wrapper__lI1qA","Text":"LogoWrapper_Text__ajbUG"};